<template>
  <div class="indexbox">
    <div class="bgbox">
      <!-- <img :src="bgImg" alt="" class="bgImg"> -->
      <div class="bgImg" :style="'background-image: url('+bgImg+');'"></div>
    </div>
    <!-- <div class="bg"></div> -->
    <div class="articlecont flex w1200">
      <!-- 左侧导航栏 -->
      <div class="left"> 
        <ul class="titlelistbox">
          <li class="titlelist" v-for="(x1,i1) in Nav" :key="i1">
            <div class="bigtitle">{{x1.bigtitle}}</div>
            <div class="smalltitle" v-for="(x2,i2) in x1.list" :key="i2">
              <span @click="navClick(x2.catalog)">{{x2.title}}</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 右侧内容区 -->
      <div class="right">
        <!-- 面包屑 -->
        <div class="toptabs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/show' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/renshi' }">人事人才</el-breadcrumb-item>
            <el-breadcrumb-item>{{mapList[catalog]}}</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="leaderBtn" v-if="catalog==='leaderBox'">
            <el-button type="primary" @click="centerDialogVisible=true">我要写信</el-button>
          </div>
        </div>
        <!-- 才市招聘 广告 -->
        <div class="renshiDetailbox guanggao" v-if="catalog==='caishizhaopin'">
          <section v-for="(x,i) in guagngao" :key="i" class="guanggao-section">
            <div class="guanggao-title">
              <p>{{x.label}}</p>
            </div>
            <div class="guanggao-box">
              <div v-for="(x2,i2) in $data[x.key]" :key="i2" class="guanggao-item" @click="navToCompanyDetail(x2.title)">
                <el-image style="width: 100px; height: 100px" :src="x2.imgUrl|toimg" fit="contain"></el-image>
                <p class="guanggao-name">{{x2.title}}</p>
              </div>
            </div>
          </section>
        </div>
        <!-- 才市预告 -->
        <div class="renshiDetailbox" v-else-if="id&&catalog==='notice'">
          <div class="contop">
            <div class="titlename">{{showData.title}}</div>
            <p class="toptips flex">
              <span class="toptime">发布时间：{{showData.createTime}}</span>
              <!-- <span class="topsrcFrom" v-if="catalog!=='leaderBox'">来源：{{showData.srcFrom}}</span> -->
              <span class="topviewTime">浏览次数：{{showData.viewTime}}</span>
            </p>
          </div>
          <div class="contbox">
            <div class="contbox-item">主办方：{{showData.host}}</div>
            <div class="contbox-item">承办：{{showData.undertake}}</div>
            <div class="contbox-item">维权：{{showData.maintain}}</div>
            <div class="contbox-item">时间：{{showData.holdDate}}</div>
            <div class="contbox-item">地点：{{showData.address}}</div>
            <div class="contbox-item">电话：{{showData.phone}}</div>
          </div>
        </div>
        <!-- 在线访谈 -->
        <div class="renshiDetailbox" v-else-if="id&&catalog==='interview'">
          <div class="contop">
            <div class="titlename">{{showData.title}}</div>
            <p class="toptips flex">
              <span class="toptime">发布时间：{{showData.createTime}}</span>
              <!-- <span class="topsrcFrom" v-if="catalog!=='leaderBox'">来源：{{showData.srcFrom}}</span> -->
              <span class="topviewTime">浏览次数：{{showData.viewTime}}</span>
            </p>
          </div>
          <div class="contbox">
            <div class="contbox-item">主题：{{showData.f_topic}}</div>
            <div class="contbox-item">时间：{{showData.f_date}}</div>
            <div class="contbox-item">嘉宾：{{showData.f_honouredGuest}}</div>
            <div class="contbox-item">简介：{{showData.f_guestDescription}}</div>
            <div class="contbox-item">访谈简介：{{showData.f_description}}</div>
            <div class="contbox-item">视频地址：{{showData.f_vodiepath}}</div>
          </div>
        </div>
        <!-- 其他详情 -->
        <div class="renshiDetailbox" v-else-if="id">
          <div class="contop">
            <div class="titlename">{{showData.title}}</div>
            <p class="toptips flex">
              <span class="toptime">发布时间：{{showData.createTime}}</span>
              <span class="topsrcFrom" v-if="catalog!=='leaderBox'">来源：{{showData.srcFrom}}</span>
              <span class="topviewTime">浏览次数：{{showData.viewTime}}</span>
            </p>
          </div>
          <div class="contbox" v-html="showData.content"></div>
        </div>
        <!-- 其他列表 -->
        <div class="cont" v-else>
          <ul class="titleul">
            <li class="titlelist" v-for="(x,i) in tableData" :key="i">
              <span class="name" @click="articleClick(x)">{{x.title}}</span>
              <span class="time">{{x.createTime}}</span>
            </li>
          </ul>
          <paging :pagesData="paging_data" @set_page_number="pageChange"></paging>
        </div>

      </div>
    </div>

    <!-- 模态框 -->
    <el-dialog
      title="我要写信" :modal="false" width="1200px" center :visible.sync="centerDialogVisible"
      :close-on-click-modal="false" @close="dialogClose">
      <div class="form-box">
        <el-form label-width="120px" ref="editForm" size="mini" :model="editForm">
          <el-row>
            <el-form-item label="选择地区">
              <areaFilter ref="areaFilter_dialog" :areaIdsChecked="areaIdsChecked" />
            </el-form-item>
            <el-form-item label="标题：" prop="title">
              <el-input v-model="editForm.title"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
            <el-form-item label="单位：" prop="organization">
              <el-input v-model="editForm.organization"></el-input>
            </el-form-item>
            <el-form-item label="通讯地址：" prop="address">
              <el-input v-model="editForm.address"></el-input>
            </el-form-item>
            <el-form-item label="邮编编码：" prop="zipCode">
              <el-input v-model="editForm.zipCode"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="editForm.email"></el-input>
            </el-form-item>
            <el-form-item label="业务类型：" prop="businessType">
              <el-input v-model="editForm.businessType"></el-input>
            </el-form-item>
            <!-- <el-form-item label="是否公开：" prop="publicMsg">
              <el-switch v-model="editForm.publicMsg"></el-switch>
            </el-form-item> -->
            <el-form-item label="内容：" prop="content">
              <wangEditor v-model="editForm.content"></wangEditor>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaFilter from '@/components/areaFilter'
import E from 'wangeditor'
import wangEditor from '@/components/wangEditor'
export default {
  components: { areaFilter, wangEditor },
  data() {
    return {
      catalog: 'examination', // 文章分类
      id: '',
      showData: '',
      tableData: [], // 获取该分类下的所有文章

      bgImg: require('../images/help-banner.jpg'),
      
      guagngao: [
        { label: '钻石VIP', key: 'guagngaoList1' },
        { label: '铂金VIP', key: 'guagngaoList2' },
        { label: '黄金VIP', key: 'guagngaoList3' },
        { label: '普通VIP', key: 'guagngaoList4' },
      ],
      guagngaoList1: [], // 钻石VIP
      guagngaoList2: [], // 铂金VIP
      guagngaoList3: [], // 黄金VIP
      guagngaoList4: [], // 普通VIP

      mapList: {
        examination: '人事招考',
        archives: '人事档案',
        information: '人事信息',
        train: '人事培训',
        notice: '才市预告',
        scene: '现场招聘',
        video: '视频招聘',
        interview: '在线访谈',
        leaderBox: '领导信箱',
        knowAll: '百事通',
        newsCenter: '新闻中心',
        caishizhaopin: '才市招聘',
      },
      
      Nav:[
        {
          bigtitle:'人事服务',
          list:[
            {title:'人事招考',catalog:'examination'},
            {title:'人事档案',catalog:'archives'},
            {title:'人事信息',catalog:'information'},
            {title:'人事培训',catalog:'train'},
          ]
        },
        {
          bigtitle:'人才超市',
          list:[
            {title:'才市预告',catalog:'notice'},
            {title:'现场招聘',catalog:'scene'},
            {title:'视频招聘',catalog:'video'},
            {title:'才市招聘',catalog:'caishizhaopin'},
          ]
        },
        {
          bigtitle:'互动交流',
          list:[
            {title:'在线访谈',catalog:'interview'},
            {title:'访谈预告',catalog:'interviewNotice'},
            {title:'访谈录播',catalog:'interviewRecording'},
            {title:'领导信箱',catalog:'leaderBox'},
            {title:'百事通',catalog:'knowAll'},
          ]
        },
        {
          bigtitle:'新闻中心',
          list:[
            {title:'新闻中心',catalog:'newsCenter'},
          ]
        },
        
      ],
      
      // 分页数据
      paging_data: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },

      centerDialogVisible: false,
      areaIdsChecked: [],
      editForm: {},

      areaId_there: '',
    }
  },
  watch: {
    pageAreaId_x(val) {
      console.log(val)
      this.areaId_there = val
      if (this.catalog === 'leaderBox') {
        this.getLeaderBoxData()
      } else if (this.catalog === 'caishizhaopin') {
        this.getGuanggaoData()
      } else {
        this.getData()
      }
      this.getAreaName()
    }
  },
  methods: {
    // 弹框
    dialogClose() {
      this.centerDialogVisible = false
      this.editForm = {}
    },
    dialogSubmit() {
      let rD = {}

      let areaNames = this.$refs.areaFilter_dialog.findAreaNames()
      const mapList = ['province','city','county','town','village']
      const mapList2 = [
        'title',
        'name',
        'organization',
        'address',
        'zipCode',
        'email',
        'businessType',
        // 'publicMsg',
        'content',
      ]

      areaNames.forEach((x, i) => {
        x ? rD[mapList[i]] = x : ''
      })

      if (!rD.province) { this.$message.warning('请选择地区') }
      else {
        (`%crD:`, 'color: #f00;', rD)
        
        mapList2.forEach(x => {
          rD[x] = this.editForm[x]
        })
        this.$api.util_create('leaderbox', rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功')
            this.dialogClose()
          } else { this._status(res.data) }
        })
      }
    },

    navToCompanyDetail(title) {
      console.log(`%c公司title:`, 'color: #f00;', title)
      this.$router.push(`/detailList?type=companyhome&page=1&oname=${title}`)
    },

    navClick(catalog) {
      document.documentElement.scrollTop = 640
      if (this.catalog !== catalog) {
        this.paging_data.currentPage = 1
      }
      this.catalog = catalog
      this.id = ''

      let fullPath = this.$route.fullPath
      let url = `/renshiNav?areaId=${this.pageAreaId_x}&catalog=${this.catalog}&page=1`
      if (fullPath !== url) {
        if (catalog === 'leaderBox') {
          this.getLeaderBoxData()
        } else if (this.catalog === 'caishizhaopin') {
          this.getGuanggaoData()
        } else {
          this.getData()
        }
        this.$router.replace(url)
      }
    },
    articleClick(data) {
      if (data.outUrl) {
        window.open(data.outUrl)
      } else {
        this.id = data.id
        let rD  = { id: data.id }
        if (this.catalog === 'leaderBox') {
          this.getLeaderBoxData(rD)
        } else if (this.catalog === 'caishizhaopin') {
          this.getGuanggaoData(rD)
        } else {
          this.catalog = data.catalog
          this.getData(rD)
        }
        this.$router.replace(`renshiNav?areaId=${this.pageAreaId_x}&catalog=${this.catalog}&page=${this.paging_data.currentPage}&id=${this.id}`)
      }
    },
    // 分页
    pageChange(num) {
      this.paging_data.currentPage = num
      this.getData()
      this.$router.replace(`renshiNav?areaId=${this.pageAreaId_x}&catalog=${this.catalog}&page=${this.paging_data.currentPage}`)
    },

    getLeaderBoxData(rD = { pageNumber: this.paging_data.currentPage }) {
      rD.publicMsg = true
      rD.areaId = this.areaId_there
      // console.log(`%crD:`, 'color: #f00;', rD)

      this.$api.util_search('leaderbox', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          if (this.id) {
            this.showData = _R[0]
            console.log(`%c信箱结果:`, 'color: #f00;', _R[0])
          } else {
            this.paging_data.total = res.data.size
            this.tableData = _R
            console.log(`%c信箱列表:`, 'color: #f00;', _R)
          }
        } else { this._status(res.data) }
      })
    },
    getGuanggaoData(rD = {}) {
      rD.areaId = this.areaId_there
      // console.log(`%crD:`, 'color: #f00;', rD)

      this.areaId_there = this.pageAreaId_x
      this.$api.util_search('guanggao', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c广告列表:`, 'color: #f00;', _R)
          this.paging_data.total = res.data.size
          _R.forEach(x => {
            this['guagngaoList' + x.userType].push(x)
          })
        } else { this._status(res.data) }
      })
    },
    getData(rD = { pageNumber: this.paging_data.currentPage }) {
      rD.catalog = this.catalog
      rD.areaId = this.areaId_there
      rD.includeParentSite = true
      this.id ? rD.id = this.id : ''
      // console.log(`%crD:`, 'color: #f00;', rD)
      
      this.$api.util_search('xinwen', rD).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          if (this.id) {
            this.showData = _R[0]
            console.log(`%c文章结果:`, 'color: #f00;', _R[0])
          } else {
            this.paging_data.total = res.data.size
            this.tableData = _R
            console.log(`%c文章列表:`, 'color: #f00;', _R)
          }
        } else { this._status(res.data) }
      })
    },
    async getAreaName() {
      this.$api.getSystem(this.pageAreaId_x).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c分站信息:`, 'color: #f00;', [_R], _R.siteName)
          this.bgImg = _R.helpCenterImgId ? this._img_handler(_R.helpCenterImgId) : require('../images/help-banner.jpg')
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    this.getAreaName()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.documentElement.scrollTop = 640
      let { catalog, page, id, areaId } = to.query
      vm.catalog = catalog ? catalog : 'examination'
      vm.paging_data.currentPage = page ? parseInt(page) : 1
      vm.id = id || ''
      vm.areaId_there = areaId || vm.pageAreaId_x
      if (vm.catalog === 'leaderBox') {
        vm.getLeaderBoxData()
      } else if (vm.catalog === 'caishizhaopin') {
        vm.guagngao.forEach(x => {
          vm[x.key] = []
        })
        vm.getGuanggaoData()
      } else {
        vm.getData()
      }
    })
  },
}
</script>

<style lang='scss' scoped>
.bgbox{
  width: 100%;
  height: 500px;
  min-width: 1240px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .bgImg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
}



.bg{
  width: 100%;height: 500px;margin-bottom: 20px;
  background: url(../images/help-banner.jpg) no-repeat;
  background-size: cover;
}
.articlecont{
  justify-content: space-between;align-items: flex-start;margin-bottom: 50px;
  .left{
    width: 20%;max-height: 785px;border: 1px solid #eee;position: sticky;top: 20px;
    .titlelistbox{
      .bigtitle{
        height: 42px;line-height: 42px;padding-left: 20px;
        background-color: cornflowerblue;color: #fff;
      }
      .smalltitle{
        font-size: 14px;height: 36px;line-height: 36px;color: #333;padding-left: 35px;
        span{cursor: pointer;}
        span:hover{color: cornflowerblue;}
      }
    }
  }
  .right{
    width: 77%;height: auto;border: 1px solid #eee;
    .el-breadcrumb{
      padding-left: 10px;height: 50px;line-height: 50px;
      background-color: #f8f8f8;border-bottom: 1px solid #eee;
    }
    ul.titleul{padding: 20px;min-height: 712px;}
    .titlelist{
      height: 42px;line-height: 42px;padding-left: 25px;
      position: relative;font-size: 14px;border-bottom: 1px dashed #888;
      &:hover{color: #ef0022;}
      .name{
        display: inline-block;width: 600px;cursor: pointer;
        overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
      }
      .time{position: absolute;right: 30px;}
    }
  }
}

.renshiDetailbox{
  width: 90%;min-height: 760px;padding: 20px 45px;
  .contop{
    border-bottom: 2px solid #abcdef;
    .titlename{text-align: center;color: #000;font-size: 24px;font-weight: bold;margin-bottom: 25px;}
    .toptips{justify-content: space-around;margin-bottom: 10px;}
  }
}


.contbox{padding: 40px 0;}
.contbox-item{padding: 10px;}

.toptabs{position: relative;}
.leaderBtn{position: absolute;right: 20px;top: 0;bottom: 0;margin: auto;height: 32px;}
.form-box{padding: 0 40px;}

.guanggao{
  &-section{margin-bottom: 20px;}
  &-title{background: #eaeaea;border-bottom: 2px solid #0077D3;}
  &-title p{background: #0077D3;width: 210px;height: 40px;line-height: 40px;color: #fff;font-weight: 600;text-align: center;}
  &-box{display: flex;flex-wrap: wrap;}
  &-item{width: 140px;height: 180px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;cursor: pointer;border: 1px solid #eee;margin: 12px;}
  &-item:hover{box-shadow: 0px 0px 20px #ccc;}
  &-name{line-height: 24px;font-size: 14px;text-align: center;padding: 0 8px;}
}

</style>